import React from 'react';
import {
    formatter, formatterCurrency
} from "../../../../utils/common";

const Widget = ({ textColorClass, value, label, isShowSale, saleValue, isShowReturn, returnValue, isShowSubValue, subValue, subSaleValue, subReturnValue }) => {
    textColorClass = textColorClass ? textColorClass : 'text-dark';
    return (
        <div className="col-md-6 col-xl" style={{ padding: 6 }}>
            <div className="summary-box">
                <div className="summary-box-body text-right">
                    <h6 className="text-truncate sb-title">{label}</h6>
                    <h5 className={`sm-value ${textColorClass}`}>{value}</h5>

                    {isShowSubValue ? (
                    <h6 className="card-box-sub-value">{subValue}</h6>
                    ) : null}
                </div>

                {(isShowSale || isShowReturn) && (
                    <div className="summary-box-footer">
                        {isShowSale ? (
                            <div className="sbf-item sbf-item-left text-center">
                                <small className="text-muted">Sale</small>
                                <div className="font-weight-bold">{saleValue}</div>

                                {isShowSubValue ? (
                                <h6 className="card-box-sub-value">{subSaleValue}</h6>
                                ) : null}
                            </div>
                        ) : null}

                        {isShowReturn ? (
                            <div className="sbf-item sbf-item-right text-center">
                                <small className="text-muted">Return</small>
                                <div className="font-weight-bold">{returnValue}</div>

                                {isShowSubValue ? (
                                <h6 className="card-box-sub-value">{subReturnValue}</h6>
                                ) : null}
                            </div>
                        ) : null}
                    </div>
                )}
            </div>
        </div>
    );
};

const ShippingIncomeTotalSummary = ({ financesSummaryState }) => {
    const totalRow = financesSummaryState.shippingIncomeDetailsTableRow;
    const totalSummary = financesSummaryState.shippingIncomeDetailsTotalSummary;
    const currency = totalSummary && totalSummary.currency ? totalSummary.currency : null;

    const widgetsData = [
        {
            value: totalRow,
            label: "Total Records",
        },
        {
            value: formatter.format(totalSummary ? totalSummary.total_before_shipping_charges : 0),
            label: "Total Gross Shipping",
        },
        {
            value: formatter.format(totalSummary ? totalSummary.total_shipping_discount : 0),
            label: "Total Discounts",
        },
        {
            textColorClass: 'text-success',
            value: formatter.format(totalSummary ? totalSummary.total_shipping_charges : 0),
            label: "Total Shipping",
            isShowSale: true,
            isShowReturn: true,
            isShowSubValue: currency && currency !== 'GBP',
            subValue: formatterCurrency((totalSummary ? totalSummary.pc_total_gross_shipping : 0), currency),
            saleValue: formatter.format(totalSummary ? totalSummary.total_sale_shipping_charges : 0),
            subSaleValue: formatterCurrency((totalSummary ? totalSummary.pc_total_sale_gross_shipping : 0), currency),
            returnValue: formatter.format(totalSummary ? totalSummary.total_return_shipping_charges : 0),
            subReturnValue: formatterCurrency((totalSummary ? totalSummary.pc_total_return_gross_shipping : 0), currency),
        },
        {
            value: formatter.format(totalSummary ? totalSummary.total_shipping_tax : 0),
            label: "Total Taxes",
            isShowSale: true,
            isShowReturn: true,
            isShowSubValue: currency && currency !== 'GBP',
            subValue: formatterCurrency((totalSummary ? totalSummary.pc_total_tax_shipping : 0), currency),
            saleValue: formatter.format(totalSummary ? totalSummary.total_sale_shipping_tax : 0),
            subSaleValue: formatterCurrency((totalSummary ? totalSummary.pc_total_sale_tax_shipping : 0), currency),
            returnValue: formatter.format(totalSummary ? totalSummary.total_return_shipping_tax : 0),
            subReturnValue: formatterCurrency((totalSummary ? totalSummary.pc_total_return_tax_shipping : 0), currency),
        },
        {
            value: formatter.format(totalSummary ? totalSummary.total_net_shipping : 0),
            label: "Total Net Shipping",
            isShowSale: true,
            isShowReturn: true,
            isShowSubValue: currency && currency !== 'GBP',
            subValue: formatterCurrency((totalSummary ? totalSummary.pc_total_net_shipping : 0), currency),
            saleValue: formatter.format(totalSummary ? totalSummary.total_sale_net_shipping : 0),
            subSaleValue: formatterCurrency((totalSummary ? totalSummary.pc_total_sale_net_shipping : 0), currency),
            returnValue: formatter.format(totalSummary ? totalSummary.total_return_net_shipping : 0),
            subReturnValue: formatterCurrency((totalSummary ? totalSummary.pc_total_return_net_shipping : 0), currency),
        },
        // {
        //     value: formatter.format(totalSummary ? totalSummary.total_shopify_shipping : 0),
        //     label: "Total Shopify",
        // },
        // {
        //     textColorClass: 'text-danger',
        //     value: formatter.format(totalSummary ? totalSummary.total_difference_with_shopify : 0),
        //     label: "Difference with Shopify",
        // },
    ];

    return (
        <div className="row" style={{ marginLeft: -6, marginRight: -6 }}>
            {widgetsData.map((widget, index) => (
                <Widget
                    key={index}
                    textColorClass={widget.textColorClass}
                    value={widget.value}
                    label={widget.label}
                    isShowSale={widget.isShowSale}
                    isShowReturn={widget.isShowReturn}
                    isShowSubValue={widget.isShowSubValue}
                    subValue={widget.subValue}
                    saleValue={widget.saleValue}
                    subSaleValue={widget.subSaleValue}
                    returnValue={widget.returnValue}
                    subReturnValue={widget.subReturnValue}
                />
            ))}
        </div>
    );
};

export default ShippingIncomeTotalSummary;
